export default "__VITE_ASSET__kS7qhTBb__"